var map = {
	"./PHOTO-2024-08-16-00-46-19.jpg": 2515,
	"./PHOTO-2024-08-16-00-46-19_1.jpg": 5447,
	"./PHOTO-2024-08-16-00-46-20.jpg": 4435,
	"./PHOTO-2024-08-16-00-47-32.jpg": 9045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6195;